import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  sessions: [],
  selectedIndex: null, // Add your additional state here
  seletctedChildIndex: null,
  subSessionTierType: "",
  defaultTierId: "",
  hasDefaultQuestionSet: false,
};
const sessionSlice = createSlice({
  name: "Session",
  initialState,
  reducers: {
    setSessions: (state, action) => {
      state.sessions = action.payload;
    },
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    setSelectedChildIndex: (state, action) => {
      state.seletctedChildIndex = action.payload;
    },
    setSelectedTierType: (state, action) => {
      state.subSessionTierType = action.payload;
    },
    setDefaultTierID: (state, action) => {
      state.defaultTierId = action.payload;
    },
    setHasDefaultQuestionSet: (state, action) => {
      state.hasDefaultQuestionSet = action.payload;
    },
  },
});
export const {
  setSessions,
  setSelectedIndex,
  setSelectedChildIndex,
  setSelectedTierType,
  setDefaultTierID,
  setHasDefaultQuestionSet,
} = sessionSlice.actions;
export default sessionSlice.reducer;
